import React from 'react';
import { useStyletron } from 'baseui';
import { Button, KIND as BUTTON_KIND, SIZE as BUTTON_SIZE } from 'baseui/button';
import { Modal, ROLE, SIZE } from 'baseui/modal';
import { HeadingXSmall, ParagraphSmall } from 'baseui/typography';
export type PendingEditActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onEnableEditing: () => void;
  title: string;
  description?: string;
};
export const PendingEditActionModal = ({
  isOpen,
  onClose,
  onEnableEditing,
  title,
  description
}: PendingEditActionModalProps) => {
  const [css, theme] = useStyletron();
  return <Modal onClose={onClose} isOpen={isOpen} size={SIZE.auto} role={ROLE.dialog} autoFocus overrides={{
    Close: {
      style: ({
        $theme
      }) => ({
        top: $theme.sizing.scale850
      })
    }
  }} mountNode={document.getElementById('modernization-side-drawer') ?? undefined}>
      <div className={css({
      display: 'flex',
      flexDirection: 'column',
      padding: `${theme.sizing.scale800} ${theme.sizing.scale600}`
    })}>
        <HeadingXSmall margin={0}>{title}</HeadingXSmall>
        {description && <ParagraphSmall margin={0} paddingTop={theme.sizing.scale200} paddingRight={theme.sizing.scale850}>
            {description}
          </ParagraphSmall>}
        <div className={css({
        display: 'flex',
        gap: theme.sizing.scale600,
        justifyContent: 'flex-end',
        paddingTop: theme.sizing.scale600
      })}>
          <Button kind={BUTTON_KIND.tertiary} size={BUTTON_SIZE.compact} onClick={onClose}>
            Cancel
          </Button>
          <Button kind={BUTTON_KIND.primary} size={BUTTON_SIZE.compact} onClick={onEnableEditing}>
            Enable editing
          </Button>
        </div>
      </div>
    </Modal>;
};